import styled from '@emotion/styled';

export default styled('div')`
  /* &:hover {
    ${ImageDescription} {
      visibility: visible;
      opacity: 0.7;
    }
  } */
`;
